module.exports = __webpack_public_path__ + "static/media/pdfIcon.c0ddfc6b.svg";